import store from '@/store'
import {http} from '@/axios'
const noActionTimeMS = 1000 * 60

export function noActionCheckStatistic() {
  setTimeout(() => {
    if(store.getters['user/isLogged']) return

    http.get('/api/counters/not_reg_on_site_1')
    http.get('/api/counters/not_reg_on_site_2')
  }, noActionTimeMS)
}


export function onResponseStatistic() {
  if(store.getters['user/isLogged']) return

  http.get('/api/counters/response_without_registration')
}

export function onIntercomeInteractionStatistic() {
  http.get('/api/counters/intercom_chat')
}